export default {"src":"/_next/static/media/constLogo1.1f68f533.svg","height":65,"width":139,"blurWidth":0,"blurHeight":0};